import React, {Component} from "react";
import logo from "../../assets/img/brand/logoMin.png";
import Fire from "../../components/firebase/Fire";
import gql from "graphql-tag";
import APIClient from "../../components/ApolloClientComponent/ApolloClient";
import {LoadingLogo} from "../../components/loading/loading-logo";
import {confirmAlert} from "react-confirm-alert";
import {Subject} from "rxjs";
import {Modal, ModalBody} from "reactstrap";
import { Select } from "@material-ui/core";

export const companyInformationStatus$ = new Subject();

const sizeOptions =[
	{ value: "0", label: 'Select company size'},
	{ value: "9", label: 'Micro (1-9)' },
	{ value: "49", label: 'Small (10-49)' },
	{ value: "249", label: 'Medium (50-249)' },
	{ value: "250", label: 'Large (250+)' }
  ];

export class CompanyInformation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: CompanyInformation.getStatusInLocalStorage(),
			activeStep: 0,
			stepLength: 3,
			industry: "",
			companySize: "",
			designation: "",
			companyId: "",
			sizeOptions: sizeOptions
		};
		this.loadIndustries = this.loadIndustries.bind(this);
		this.loadProfileInfo = this.loadProfileInfo.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleChangeCompanySize = this.handleChangeCompanySize.bind(this);
		this.onClickNextButton = this.onClickNextButton.bind(this);
		this.getUser = this.getUser.bind(this);
		this.getCompany = this.getCompany.bind(this);
		this.renderContent = this.renderContent.bind(this);
		this.renderStepOne = this.renderStepOne.bind(this);
		this.renderStepTwo = this.renderStepTwo.bind(this);
		this.renderStepThree = this.renderStepThree.bind(this);
		this.renderDots = this.renderDots.bind(this);
		this.updateCompany = this.updateCompany.bind(this);
		this.updateUser = this.updateUser.bind(this);
		companyInformationStatus$.subscribe((status) => {
			if (!status) {
				this.setState({
					status,
					activeStep: 0,
					loading: true,
				}, () => {
					this.loadProfileInfo();
					CompanyInformation.setStatusToLocalStorage(false);
				});
			} else {
				this.setState({
					status,
				});
			}
		});
	}

	static getStatusInLocalStorage() {
		return JSON.parse(localStorage.getItem("company-information") || "false");
	}

	static setStatusToLocalStorage(value = true) {
		return localStorage.setItem("company-information", value.toString());
	}

	componentDidMount() {
		if (!this.state.status && Fire.auth().currentUser) {
			this.setState({
				loading: true,
			}, () => {
				this.loadProfileInfo();
			});
		} else {
			this.setState({
				status: true,
			});
		}
	}

	loadProfileInfo() {
		this.getUser().then(({data: {user}}) => {
			return this.getCompany(user).then((result) => ({...result, user}));
		}).then(({data: {company}, user}) => {
			this.setState({
				industry: company.industry,
				companySize: company.size,
				companyId: company.id,
				designation: user.designation,
				user,
				company,
			}, () => {
				if (this.state.companySize > 0) {
					this.setState({status: true, loading: false}, () => {
						CompanyInformation.setStatusToLocalStorage();
					});
				} else {
					this.loadIndustries();
				}
			});
		}).catch(error => {
			this.setState({loading: false});
			confirmAlert({
				message: error.message.substring(15),
				closeOnEscape: true,
				closeOnClickOutside: true,
			});
		});
	}

	getUser() {
		const currentUserId = Fire.auth().currentUser.uid;
		return APIClient.query({
			fetchPolicy: "no-cache",
			query: gql`
          query user($userId: ID!) {
              user(id: $userId) {
                  firstName
                  lastName
                  email
                  phone
                  type
                  designation
                  defaultValues
              }
          }
			`,
			variables: {
				userId: currentUserId
			}
		});
	}

	getCompany(user) {
		return APIClient.query({
			fetchPolicy: "cache-first",
			query: gql`
          query company($companyId: ID!) {
              company(id: $companyId) {
                  id
                  name
                  size
                  industry{
                      id
                      title
                  }
              }
          }
			`,
			variables: {
				companyId: user.defaultValues.company
			}
		});
	}

	loadIndustries() {
		APIClient.query({
			fetchPolicy: "no-cache",
			query: gql`
          query industries {
              industries {
                  id
                  title
              }
          }
			`
		}).then(({data: {industries}}) => {
			this.setState({
				industries: industries,
				loading: false,
			});
		}).catch(err => {
			this.setState({loading: false});
			confirmAlert({
				message: err.message.substring(15),
				closeOnEscape: true,
				closeOnClickOutside: true,
			});
		});
	}

	handleChange(e) {
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	handleChangeCompanySize(e){
		

		console.log(e.target.value);
		if(e.target.value !== "0"){
			this.setState({
				companySize: e.target.value
			});
		}else{
			this.setState({
				companySize:""
			});

		}
		

		
	}


	onClickNextButton() {
		if (this.state.activeStep === 1) {
			this.setState({
				loading: true,
			}, () => {
				this.updateUser().then(() => {
					return this.updateCompany();
				})
					.then(() => {
						this.setState({
							loading: false,
							activeStep: this.state.activeStep + 1,
						});
						CompanyInformation.setStatusToLocalStorage();
					})
					.catch(err => {
						confirmAlert({
							message: err.message.substring(15),
							closeOnEscape: true,
							closeOnClickOutside: true,
						});
						this.setState({
							loading: false,
						});
					});
			});
		} else {
			this.setState({
				activeStep: this.state.activeStep + 1,
			});
		}
	}

	updateUser() {
		const currentUserId = Fire.auth().currentUser.uid;
		return APIClient.mutate({
			fetchPolicy: "no-cache",
			mutation: gql`
          mutation updateUser($newUserData: UserInput!) {
              updateUser(newUserData: $newUserData) {
                  firstName
                  lastName
                  email
                  phone
                  type
                  designation
                  defaultValues
              }
          }
			`,
			variables: {
				newUserData: {
					firstName: this.state.user.firstName,
					lastName: this.state.user.lastName,
					email: this.state.user.email,
					phone: this.state.user.phone,
					type: this.state.user.type,
					defaultValues: this.state.user.defaultValues,
					uid: currentUserId,
					designation: this.state.designation,
				}
			}
		});
	}

	updateCompany() {
		const currentUserId = Fire.auth().currentUser.uid;
		return APIClient.mutate({
			fetchPolicy: "no-cache",
			mutation: gql`
          mutation updateCompany(
              $userId: ID!
              $companyId: ID!
              $newCompanyData: CompanyInput!
          ) {
              updateCompany(
                  userId: $userId
                  companyId: $companyId
                  newCompanyData: $newCompanyData
              ) {
                  size
              }
          }
			`,
			variables: {
				userId: currentUserId,
				companyId: this.state.companyId,
				newCompanyData: {
					isStartup: this.state.companySize <= 10,
					name: this.state.company.name,
					industry: this.state.industry,
					size: parseInt(this.state.companySize),
				}
			}
		});
	}

	renderContent() {
		return (
			<div>
				{
					this.state.activeStep === 0
						? this.renderStepOne()
						: this.state.activeStep === 1
						? this.renderStepTwo()
						: this.state.activeStep === 2
							? this.renderStepThree()
							: null
				}
				{
					this.state.activeStep <= 1
						? (
							<div className="row justify-content-between mt-5">
								<div className="col-4">
									&nbsp;
								</div>
								<div className="col-4">
									{
										this.renderDots()
									}
								</div>
								<div className="col-4 text-right">
									<button className="btn btn-lg btn-link p-0"
													disabled={
														this.state.activeStep === 1
														&& (
															!this.state.industry
															|| !this.state.companySize
															|| !this.state.designation
														)
													}
													onClick={this.onClickNextButton}>
										Next
									</button>
								</div>
							</div>
						)
						: null
				}
			</div>
		);
	}

	renderStepOne() {
		return (
			<div>
				<div className="text-center my-2">
					<img style={{maxWidth: "160px", maxHeight: "160px"}} src={logo} alt="TalentScript"/>
				</div>
				<div className="h3 text-center">Welcome to TalentScript!</div>
				<div className="h4 text-center font-weight-normal mb-5">Hire faster with 3 easy steps</div>
				<div className="d-flex justify-content-between">
					<div style={{maxWidth: "130px"}}>
						<div className="rounded p-3 mb-3 mx-auto text-center">
							<i className="ci ci-setting-build fa-6x" style={{color: "#5cd3ff"}}/>
						</div>
						<div className="h4 text-center mb-1">Build</div>
						<div className="h6 text-center font-weight-normal mb-0">
							Create Job Profile
						</div>
					</div>
					<div style={{maxWidth: "130px"}}>
						<div className="rounded p-3 mb-3 mx-auto text-center">
							<i className="ci ci-share  fa-6x" style={{color: "#5cd3ff"}} />
						</div>
						<div className="h4 text-center mb-1">Share</div>
						<div className="h6 text-center font-weight-normal mb-0">
							Post Interview Link
						</div>
					</div>
					<div style={{maxWidth: "130px"}}>
						<div className="rounded p-3 mb-3 mx-auto text-center" >
							<i className="ci ci-check-list fa-6x" style={{color: "#5cd3ff"}}/>
						</div>
						<div className="h4 text-center mb-1">Evaluate</div>
						<div className="h6 text-center font-weight-normal mb-0">
							Screen & Schedule Personal Interviews
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderStepTwo() {
		return (
			<div className="px-5">
				<div className="my-5 py-5 text-center h3">Before we start, we would like to know more about you</div>
				<div className="form-group mb-4">
					<label htmlFor="industry" className="h4 mb-2">
						Industry
					</label>
					<select
						onChange={this.handleChange}
						className="form-control form-control-lg"
						name="industry"
						id="industry"
						placeholder="Pick one"
						value={this.state.industry || ""}>
						{
							this.state.industries
								? this.state.industries.map((item, index) => {
									return <option value={item.id} key={index}>{item.title}</option>;
								})
								: <option>Pick one</option>
						}
					</select>
				</div>
				<div className="form-group mb-4">
					<label htmlFor="company-size" className="h4 mb-2">
						Company Size
					</label>

					<select
						onChange={this.handleChangeCompanySize.bind(this)}
						className="form-control form-control-lg"
						name="companySize"
						id="company-size"
						placeholder="Pick your company size"
						value={this.state.companySize || ""}>
						{
							this.state.sizeOptions
								? this.state.sizeOptions.map((item, index) => {
									return <option value={item.value} key={index}>{item.label}</option>;
								})
								: <option>Pick one</option>
						}
					</select>


				</div>
				<div className="form-group mb-4">
					<label htmlFor="designation" className="h4 mb-2">
						Title
					</label>
					<input
						onChange={this.handleChange}
						type="text"
						className="form-control form-control-lg"
						name="designation"
						id="designation"
						placeholder="Position"
						value={this.state.designation}/>
				</div>
			</div>
		);
	}

	renderStepThree() {
		return (
			<div>
				<div className="my-5 py-5 text-center h3">What Brings You Here?</div>
				<div className="d-flex justify-content-between">
					<a
						href="#/base/jobs/new"
						ref={(node) => {
							if (node) {
								node.style.setProperty("border-color", "#5cd3ff", "important");
							}
						}}
						onClick={() => {
							localStorage.setItem("calendarhelp", true);
							localStorage.setItem("AllJobs",true);
							localStorage.setItem("JobInformation",true);
							localStorage.setItem("candidateInformation",true);
							localStorage.setItem("reportTooltip",true);

							this.setState({
								status: true,
							});
						}}
						className="d-block rounded px-5 py-4 mb-3 text-center border cursor-pointer text-decoration-none">
						<i className="ci ci-hired fa-10x" style={{color: "#5cd3ff"}}/>
						<div className="h4 text-center mb-0 mt-3" style={{color: "#5cd3ff"}}>I’m Hiring</div>
					</a>
					<a
						href="#/home"
						ref={(node) => {
							if (node) {
								node.style.setProperty("border-color", "#5cd3ff", "important");
							}
						}}
						onClick={() => {
							localStorage.setItem("startTour", true);
							this.setState({
								status: true,
							});
						}}
						className="d-block rounded px-5 py-4 mb-3 text-center border cursor-pointer text-decoration-none">
						<i className="ci ci-search-3d fa-10x" style={{color: "#5cd3ff"}}/>
						<div className="h4 text-center mb-0 mt-3" style={{color: "#5cd3ff"}}>I’m Exploring</div>
					</a>
				</div>
			</div>
		);
	}

	renderDots() {
		return (
			<div className="text-center">
				{
					(new Array(this.state.stepLength)).fill("").map((item, index) => {
						return (
							<div
								key={index}
								className="d-inline-block rounded-circle mx-2"
								style={
									{
										backgroundColor: index === this.state.activeStep ? "#5cd3ff" : "#dbdbdb",
										width: "10px",
										height: "10px",
									}
								}/>
						);
					})
				}
			</div>
		);
	}

	render() {
		return (
			<Modal
				isOpen={!this.state.status && !this.state.loading}
				toggle={() => {}}
				centered={true}
				style={{ maxWidth: "650px", width: "auto" }}
				zIndex={1051}
			>
				<ModalBody>
					<div className="px-5 pb-5">
						{
							this.state.loading
								? null
								: !this.state.status
									?this.renderContent()
									:<div></div>
						}
					</div>
				</ModalBody>
			</Modal>
		)
	}
}
